import { PlaylistAsset } from '../index'

export default class PlaylistsAsset {
  constructor(obj) {
    this.playlists = []

    this.title = obj.title
    this.type = 'playlists'

    if (obj && obj.blocks && obj.blocks.length > 0) {
      obj.blocks = obj.blocks.slice(0, 5)
      this.playlists = obj.blocks.map(blck => {
        return new PlaylistAsset(blck)
      })
    }
  }

  get blocks() {
    return this.playlists
  }
}
